module.exports = __webpack_public_path__ + "static/media/add.eed26ba5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/AdminsScreen/AdminsScreenTable/assets/add.svg
// module id = 2047
// module chunks = 0